import { toLandingLeadForm } from '../articles/landing_lead_form';

pageLoad('pages_how_to_choose_box', () => {
  $('.summary-block .summary-button').on('click', toLandingLeadForm);
});
